import { render, staticRenderFns } from "./OmsAgTable.vue?vue&type=template&id=51d4a9e4&scoped=true"
import script from "./OmsAgTable.vue?vue&type=script&lang=js"
export * from "./OmsAgTable.vue?vue&type=script&lang=js"
import style0 from "./OmsAgTable.vue?vue&type=style&index=0&id=51d4a9e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4a9e4",
  null
  
)

export default component.exports